function offer_Reducer(state = [], action) {
    switch (action.type) {
        case 'OFFER/SET':            
            return action.offer;
        case 'OFFER/CLEAR':
            return null;
        default:
            return state;
    }
}

export default offer_Reducer;
